<template>
  <div
    :class="[
      orientationCustomize,
      hasGrid ? gridCustomize : [xlGrid, lgGrid, mdGrid, smGrid],
    ]"
  >
    <ontick-card-title v-if="title" class="block px-3 pb-6">{{
      title
    }}</ontick-card-title>
    <!-- <div :class="[!noBackground ? 'bg-ontick-card shadow' : '', 'rounded-lg overflow-hidden w-full', paddingCustomize]" :style="borderCustomize"> -->
    <div
      :class="[
        !noBackground ? 'bg-gray-50 shadow dark:bg-ontick-graphite-500' : '',
        'w-full rounded-lg border border-ontick-steel-300 dark:border-ontick-graphite-500',
        paddingCustomize,
      ]"
      :style="borderCustomize"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ontick-card",
  props: {
    border: {
      type: String,
    },
    borderLeft: {
      type: String,
    },
    orientation: {
      type: String,
      default: "vertical",
      validator: function (value) {
        return ["horizontal", "vertical"].indexOf(value) !== -1;
      },
    },
    padding: {
      type: String,
      default: "6",
    },
    noBackground: {
      type: Boolean,
      default: false,
      validator: function (value) {
        return [true, false].indexOf(value) !== -1;
      },
    },
    title: {
      type: String,
    },
    grid: {
      type: String,
    },
    xl: {
      type: String,
      default: "12",
    },
    lg: {
      type: String,
      default: "12",
    },
    md: {
      type: String,
      default: "12",
    },
    sm: {
      type: String,
      default: "12",
    },
  },
  computed: {
    borderCustomize() {
      return this.border
        ? `border: 2px solid ${this.border}`
        : this.borderLeftCustomize;
    },
    borderLeftCustomize() {
      return this.borderLeft ? `border-left: 3px solid ${this.borderLeft}` : "";
    },
    orientationCustomize() {
      return {
        flex: this.orientation == "horizontal",
        block: this.orientation == "vertical",
      };
    },
    paddingCustomize() {
      return { [`p-${this.padding}`]: true };
    },
    hasGrid() {
      return this.grid ? true : false;
    },
    gridCustomize() {
      return this.grid ? { [`col-span-${this.grid}`]: true } : {};
    },
    xlGrid() {
      return { [`xl:col-span-${this.lg}`]: true };
    },
    lgGrid() {
      return { [`lg:col-span-${this.lg}`]: true };
    },
    mdGrid() {
      return { [`md:col-span-${this.md}`]: true };
    },
    smGrid() {
      return { [`sm:col-span-${this.sm}`]: true };
    },
  },
};
</script>
